import React, { useState } from "react";
import { Tabs } from "antd";
import Heading from "../../../components/Heading";
// import ViewAudit from "./ViewAudit";
import ViewAudit from "../AuditScannedTable";

import AuditInputs from "./AuditInputs";
import { useParams } from "react-router-dom";

import "./style.scss";
import constants from "../../../constants/constants";
import BulkAudit from "./BulkAudit";
import XRayAudit from "./XRayAudit";

const AuditTabs = () => {
  let userinfo = JSON.parse(localStorage.getItem("userinfo"));
  const { ROLES } = constants;
  const { HO_ADMIN, HUB_ADMIN, ROLE_HUBOPERATOR, ROLE_HUBXRAYOPERATOR, DEVELOPER } =
    ROLES;

  const userRoles = userinfo?.roles || [];
  let parmas = useParams();
  const [activeKey, setActiveKey] = useState("1");

  const changeTab = (key) => {
    setActiveKey(key);
  };

  const tabDefs = [
    {
      label: "Audit",
      role: [HUB_ADMIN, ROLE_HUBOPERATOR],
      render: () => <AuditInputs awb={parmas.id} changeTab={changeTab} />,
    },
    {
      label: "View Audit",
      role: [HO_ADMIN, HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
      render: () => <ViewAudit activeKey={activeKey} />,
    },
    {
      label: "Bulk Audit",
      role: [HO_ADMIN, HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
      render: (key) => <BulkAudit activeKey={activeKey} tabKey={key} />,
    },
    {
      label: "X-Ray Audit",
      role: [HUB_ADMIN, ROLE_HUBXRAYOPERATOR, DEVELOPER],
      render: (key) => <XRayAudit activeKey={activeKey} tabKey={key} />,
    },
  ];

  const items = tabDefs
    .filter((tab) => tab.role.some((r) => userRoles.includes(r)))
    .map((tab, idx) => {
      const key = String(idx + 1);
      return { label: tab.label, key, children: tab.render(key) };
    });

  return (
    <div className="p-2">
      <Heading title={"Audit"} />
      <div className="audit-tab-container">
        <Tabs activeKey={activeKey} onChange={changeTab} items={items} />
      </div>
    </div>
  );
};

export default AuditTabs;
